import { HOST_READY } from "@websim/core/src/parent-api/host-ready";
import { ParentApi } from "@websim/core/src/parent-api/types";
import { connectClient } from "@websim/message-proxy/client";
import { memoizePromise } from "./memoize-promise";

declare const __WEBSIM_DATA__: import("./types").WebsimData;

export const parentApi =
  __WEBSIM_DATA__.isTopLevelFrame && __WEBSIM_DATA__.project_id
    ? (() => {
        const windowPromise = new Promise<Window>((resolve) => {
          // Create and append iframe when in top level frame
          const iframe = document.createElement("iframe");
          iframe.sandbox.add(
            "allow-scripts",
            "allow-popups",
            "allow-same-origin",
            "allow-modals"
          );
          iframe.style.display = "none";

          const project_id = __WEBSIM_DATA__.project_id;
          const url = new URL(
            `/_embedded_host/${project_id}`,
            __WEBSIM_DATA__.hostOrigin
          );
          url.searchParams.set("__websim_content_frame_origin", window.origin);
          url.searchParams.set(
            "__websim_route",
            JSON.stringify(__WEBSIM_DATA__.route)
          );
          iframe.src = url.toString();

          if (document.body) {
            document.body.appendChild(iframe);
            resolve(iframe.contentWindow!);
          } else {
            document.addEventListener("DOMContentLoaded", () => {
              document.body.appendChild(iframe);
              resolve(iframe.contentWindow!);
            });
          }
        });

        const parentIsReady: Promise<Window> = windowPromise.then((w) => {
          return new Promise((resolve) => {
            const fn = (event: MessageEvent) => {
              const host_ready = "host_ready" satisfies HOST_READY;
              if (event.data.type === host_ready) {
                resolve(w);
                window.removeEventListener("message", fn);
              }
            };
            window.addEventListener("message", fn);
          });
        });

        const proxy = connectClient<ParentApi>(
          "parent",
          __WEBSIM_DATA__.hostOrigin,
          parentIsReady
        );
        return proxy;
      })()
    : connectClient<ParentApi>(
        "parent",
        __WEBSIM_DATA__.hostOrigin,
        new Promise<Window>((resolve) => {
          const fn = (event: MessageEvent) => {
            const host_ready = "host_ready" satisfies HOST_READY;
            if (event.data.type === host_ready) {
              resolve(window.parent);
              window.removeEventListener("message", fn);
            }
          };
          window.addEventListener("message", fn);
        })
      );

// For the Home page
(window as any).__get_params__ = memoizePromise(parentApi.getParams);
